<div class="topnav-container">
    <app-topnav></app-topnav>
</div>
<div class="body-container">
    <div class="limit-form-wrapper">
        <h1>Fala connosco</h1>
        <app-contact-form [ContactType]="'Geral'"></app-contact-form>
    </div>
</div>